import React, { useState, Fragment } from "react";
import { useQueryClient } from 'react-query';
import moment from "moment";

import useAirports from "../../../services/airports/useAirports";

const AirportNameTooltip = (props) => {
  const airportCode = props.airportCode;
  const tooltipSuffix = props.suffix || "";

  const [load, setLoad] = useState("WAIT");
  const queryClient = useQueryClient();
  //pass a dummy key so hits to cache will return dummy record until rendering tooltip
  const airportName = useAirports({ queryClient, extraKeys: [airportCode], useCache: true});

  let toolTipText = "Retrieving info...";

  if (airportName.error) {
    toolTipText = "...";
  }

  if (airportName.data) {
    if (props.onChange && Array.isArray(airportName.data) && airportName.data.length > 0) {
      props.onChange(airportName.data[0]);

      return <></>;
    }

    const rows = airportName.data;
    if (rows) {
      toolTipText = (
        <Fragment>
          <span>
            {
              rows.map((row, i) => {
                return((i > 0 ? ", " : "") + row.airportName);
              })
            }
          </span>
          <span>{tooltipSuffix}</span>
        </Fragment>
      );
    } else {
      toolTipText = "";
    }
  };

  if (props.onChange === undefined)
    return (
      <span>{toolTipText}</span>
    );
  else return <></>;
}

export default AirportNameTooltip;